import { combineReducers } from 'redux';
import formReducers from 'import/reducers/import_form_reducers';
import listReducers from 'import/reducers/import_list_reducers';

export const importReducers = combineReducers({ form: formReducers, list: listReducers });



// WEBPACK FOOTER //
// src/modules/secured/modules/import/reducers/index.js